export class PointCloudOctreeNode {
    geometryNode;
    sceneNode;
    pcIndex = undefined;
    boundingBoxNode = null;
    children;
    loaded = true;
    isTreeNode = true;
    isGeometryNode = false;
    constructor(geometryNode, sceneNode) {
        this.geometryNode = geometryNode;
        this.sceneNode = sceneNode;
        this.children = geometryNode.children.slice();
    }
    dispose() {
        this.geometryNode.dispose();
    }
    disposeSceneNode() {
        this.sceneNode.dispose();
    }
    traverse(cb, includeSelf) {
        this.geometryNode.traverse(cb, includeSelf);
    }
    get id() {
        return this.geometryNode.id;
    }
    get name() {
        return this.geometryNode.name;
    }
    get level() {
        return this.geometryNode.level;
    }
    get isLeafNode() {
        return this.geometryNode.isLeafNode;
    }
    get numPoints() {
        return this.geometryNode.numPoints;
    }
    get index() {
        return this.geometryNode.index;
    }
    get boundingSphere() {
        return this.geometryNode.boundingSphere;
    }
    get boundingBox() {
        return this.geometryNode.boundingBox;
    }
    get spacing() {
        return this.geometryNode.spacing;
    }
}
